
import BotAnalyticsService from "./bot-analytics.service";
import GlobalStoreService from "./global-store.service";
import { globalConstants } from "../constants/globalConstants";
import UtilService from "./util.service";
import TrackingKey from '../enums/trackingKey'

class TrackingMiddlewareService {

    pageName = "leadIframe"
    platform = (window.MyAirtelAppReact || window.MyAirtelChatAppReact) ? "APP" : "WEB"
    platformType = null
    sessionId = null
    circle = ""
    startTime = new Date()

    user_response = ""
    enteredTextMode = "";
    scenarioName = ""
    scenarioStrategy = ""
    user_suggestion = ""
    intentScore = ""


    setTrackingData({ circle, enteredTextMode, user_response, current_scenario, user_suggestion, scenarioName, scenarioStrategy, intentScore }) {
        // console.log({circle,enteredTextMode,user_response,current_scenario,user_suggestion,scenarioName,scenarioStrategy})

        if (current_scenario) {
            if (current_scenario.scenario && current_scenario.scenario.scenarioName &&
                current_scenario.scenario.scenarioName !== "BAD_FEEDBACK"
                && current_scenario.scenario.scenarioName !== "GOOD_FEEDBACK") {

                this.scenarioName = current_scenario.scenario && current_scenario.scenario.scenarioName
                    ? current_scenario.scenario.scenarioName : ""

                this.scenarioStrategy = current_scenario.scenario && current_scenario.scenario.scenarioStrategy
                    ? current_scenario.scenario.scenarioStrategy : ""
            }
        }
        if (circle) {
            this.circle = circle
        }
        if (enteredTextMode) {
            this.enteredTextMode = enteredTextMode
        }
        if (user_response || user_response === "") {
            this.user_response = user_response
        }
        if (user_suggestion) {
            this.user_suggestion = user_suggestion
        }
        if (scenarioName !== undefined) {
            this.scenarioName = scenarioName
        }
        if (scenarioStrategy !== undefined) {
            this.scenarioStrategy = scenarioStrategy
        }
        this.intentScore = intentScore
    }

    trackEvent(trackingEnumKey) {

        if (!this.sessionId) {
            let sessionID = UtilService.generateUniqueSessionId();
            this.sessionId = sessionID
            window.sessionID = sessionID

            // console.log('set sessionID',window.sessionID)
        }
        if (!this.platformType) {
            let platformType = UtilService.getPlatformTypeForTracking()
            this.platformType = platformType
            window.platformType = platformType
            // console.log('set platformType',window.platformType)
        }
        //set the tracking key
        window.my_data = trackingEnumKey;
        window.circle = this.circle;
        window.mobileNumber = GlobalStoreService.get("currentNumber") || GlobalStoreService.get("primaryNumber") || null;
        window.numberType = GlobalStoreService.get("currentBotType")
        window.loginType = GlobalStoreService.get("loginType")

        //set the tracking variables in window variables

        window.optionSelected = this.user_response || "N/A";
        window.intentType = this.scenarioStrategy || "N/A";
        window.selectedBy = this.enteredTextMode || "N/A";
        window.feedbackSuggestion = this.user_suggestion || "N/A";
        window.scenario = this.scenarioName || "N/A";
        window.intentScore = this.intentScore || "N/A"


        // console.log('platformType',window.platformType)

        switch (trackingEnumKey) {
            case TrackingKey.CLOSE_CHAT_NO:
            case TrackingKey.INTENT_READING_FAIL:
            case TrackingKey.ERROR_FRONTEND:
            case TrackingKey.CLOSE_CHAT_YES:
                window.sessionTime = privateMethods.getTotalSessionTimeInSeconds();
                break;
            case TrackingKey.IMPROVE_FEEDBACK_SKIPPED:
                this.user_suggestion = "sad_skipped"
                window.feedbackSuggestion = "sad_skipped"
                window.my_data = TrackingKey.FEEDBACK_SKIPPED
                break;
            case TrackingKey.ERROR_BACKEND:
                window.errorType = "API_ERROR"
                break;
            case TrackingKey.INTENT_READING_SUCCESS:
                window.intentScore = this.intentScore
                break;
            default: { }

        }

        if (trackingEnumKey === TrackingKey.SWITCH_CLICK_POST_TO_PRE || trackingEnumKey === TrackingKey.SWITCH_CLICK_PRE_TO_POST) {
            window._satellite.track("generic-click");
        }
        else {
            let window_obj = {
                optionSelected: window.optionSelected,
                intentType: window.intentType,
                selectedBy: window.selectedBy,
                feedbackSuggestion: window.feedbackSuggestion,
                scenario: window.scenario,
                intentScore: window.intentScore
            }
            // console.log(trackingEnumKey)
            // console.log(window.my_data)
            // console.log(window_obj)
            window._satellite.track("chatbot");
            this.user_suggestion = "N/A"
        }
    }

    setTrackingForSSOMultiple = (userProfile) => {
        let str = ''
        if (userProfile && userProfile.products) {
            let lob_arr = Object.keys(userProfile.products)
            for (let i = 0; i < lob_arr.length; i++) {
                if (userProfile.products[lob_arr[i]].length > 0) {
                    for (let j = 0; j < userProfile.products[lob_arr[i]].length; j++) {
                        str = str + `m=${userProfile.products[lob_arr[i]][j]['siNumber']},l=${lob_arr[i]}|`
                    }
                }
            }
            // console.log('multiple tracking str', str)
            window.ssoProfile = str
        }
    }
}

var trackingMiddlewareService = new TrackingMiddlewareService();

export default trackingMiddlewareService

const privateMethods = {

    getTotalSessionTimeInSeconds() {
        return (new Date().getTime() - trackingMiddlewareService.startTime.getTime()) / 1000;
    }
}


// WEBPACK FOOTER //
// ./src/services/tracking-middleware.service.js